export const getChangeItemViewAction = "MEMEBER_SERVICE/VIEW/CHANGE_ITEM";
export const getChangeItemViewSuccessAction = "MEMEBER_SERVICE/VIEW/CHANGE_ITEM/SUCCESS";
export const getChangeItemViewFailAction = "MEMEBER_SERVICE/VIEW/CHANGE_ITEM/FAIL";
export const getChangeViewResetAction = "MEMEBER_SERVICE/VIEW/CHANGE_ITEM/RESET";
